import HeaderFilter from '../../components/HeaderFilter';
import { useAuthStore } from '../../store';
import CanvassTable from './CanvassTable';
import CanvassForm from './CanvassForm';
import { CANVASS_API } from '../../hooks/useCanvassHooks';

/**
 * Supplier canvassing -- steps 5 to 10 of the sourcing flow.
 *
 * Lists the comparisons purchasing has run: which suppliers were approached for
 * a material, what each quoted, and which one was chosen.
 */
const CanvassPage = () => {
  const moduleName = 'Canvass';
  const moduleCode = 'CANVASS';

  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );

  return (
    <div className={'page-wrapper'}>
      <HeaderFilter showCreate={userModuleAccess?.create} />
      <CanvassForm api={CANVASS_API} moduleName={moduleName} />
      <CanvassTable
        api={CANVASS_API}
        moduleName={moduleName}
        moduleCode={moduleCode}
      />
    </div>
  );
};

export default CanvassPage;
